import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { MessageService } from 'primeng/api';
import { ManageCampaignService } from 'src/app/private/services/manage-campaign.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-test-call',
  imports: [SharedModule, NgxIntlTelInputModule],
  templateUrl: './test-call.component.html',
  styleUrl: './test-call.component.scss'
})
export class TestCallComponent {


  @Output() closeDialog = new EventEmitter<any>();

  constructor(private fb: FormBuilder,
    private api : ManageCampaignService,
    private localStorage : LocalStorageService,
    private messageService : MessageService
  ) { }

  @Input() campData: any = {};

  btnLoading: boolean = false;
  isDropdownOpen: boolean = false;

  phoneForm!: FormGroup;
  phoneNumberUtil = PhoneNumberUtil.getInstance();
  timeWhenCallStarted: any;
  timeWhenCallEnded: any;
  hangUpCallData: any;

  simpleSDK: any;
  notes: string = '';
  isDialerReady: boolean = false;
  btnLoading3: boolean = false;
  isOpenNotesModal: boolean = false;


  ngOnInit(): void {

    this.phoneForm = this.fb.group({
      phone: ['', [Validators.required]]
    });
  }

  
  // Helper function to set phone value dynamically


  // Custom validator to ensure phone number matches country code
  isPhoneNumberValid(phoneNumber: any): boolean {
    try {
      const parsedNumber = this.phoneNumberUtil.parseAndKeepRawInput(
        phoneNumber.number,
        phoneNumber.countryCode
      );
      return this.phoneNumberUtil.isValidNumber(parsedNumber);
    } catch (error) {
      console.error('Error validating phone number:', error);
      return false;
    }
  }

  // Close the modal
  closeModal() {
    this.closeDialog.emit();
    // this.close.emit();
  }

  handleCloseAllDialogs() {
    this.isOpenNotesModal = false;
    this.closeDialog.emit();
  }

  // Handle Proceed button click
  onProceed(): void {
    if (this.phoneForm.valid) {
      const phoneNumber = this.phoneForm.get('phone')?.value;

      if (this.isPhoneNumberValid(phoneNumber)) {
       
        this.btnLoading = true;
        const payload = {
          organizationId : this.localStorage.getOrganizationId(),
          campusId : this.localStorage.getCampusId(),
          mobile_number : this.removeSpaces(phoneNumber?.number),
          contact_group_id : this.campData?.contact_group_id || null,
        }

        this.api.testDialCustomer(payload).subscribe({
          next : (res) => {
            this.btnLoading = false;
            this.messageService.add({severity:'success', summary:'Success', detail:'Call initiated successfully'});
            console.log("Test call response", res);
          },
          error : (err) => {
            this.btnLoading = false;
            this.messageService.add({severity:'error', summary:'Error', detail:'Failed to initiate call'});
            console.error("Test call error", err);
          }
        })
      } else {
        console.error('Invalid phone number');
      }
    }
  }


  removeSpaces(str: string): string {
    return str.replace(/\s+/g, '');
  }

}
